import React, { useState, useEffect } from 'react'
import CreditContent from '../common/creditSection'
import { useLocation } from 'react-router-dom'
import CustomPagination from '../ResumeSection/Pagination'
import '../../../styles/globalStyle.css';
import search from '../../../assets/Group 33509.png';
import upload from '../../../assets/download-cloud-01.png';
import closeIcon from '../../../assets/Close.png';
import { useSelector, useDispatch } from 'react-redux';
import Loader from '../../loader/Loader';
import { viewResume } from '../../../services/operations/ResumesAPI';
import Card from 'react-bootstrap/Card';
import { FaLocationDot } from "react-icons/fa6";
import { MdWork } from "react-icons/md";
import { RiArrowDropRightFill } from "react-icons/ri";
import debounce from "lodash.debounce";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { getPassiveCandidates } from '../../../services/operations/JobPostAPI';
import { get } from 'react-hook-form';
import SkeletonLoader from '../ResumeSection/Skeleton';
import { getUserDetails } from '../../../services/operations/ProfileAPI';
import eyeIcon from '../../../assets/icons8-eye-30.png'
import ownerIcon from '../../../assets/icons8-landlord-24.png'
import touchIcon from "../../../assets/touch_app.svg"

const RelevantCandidate = () => {

    const [data, setData] = useState([])
    const [loadData, setLoadData] = useState(false);
    const [isDataReady, setIsDataReady] = useState(false);
    const [result, setResult] = useState([]);
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 15,
        total_pages: 1,
        total: ""
    });
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get('data');
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token)
    const loading = useSelector((state) => state.auth.loading)

    useEffect(() => {
        if (encodedData) {
            const decodedData = JSON.parse(decodeURIComponent(atob(encodedData)));
            setData(decodedData);
            setIsDataReady(true);
        }
    }, [encodedData]);



    useEffect(() => {
        const fetchCandidates = async () => {
            if (!data || !pagination.current_page) return;

            setLoadData(true);

            let niceToHaveSkills = [];
            niceToHaveSkills =
                typeof data?.niceToHaveSkills === "string"
                    ? JSON.parse(data.niceToHaveSkills)
                    : data?.niceToHaveSkills || [];
            const payload = {
                job_id: data.jobId,
                skills: JSON.parse(data?.skills || "[]"),
                nice_to_have_skills: niceToHaveSkills,
                location: data.location || "",
                experience: data?.experience,
                page: pagination.current_page
            };

            const result = await dispatch(getPassiveCandidates(payload, token));
            setResult(result?.data?.resumes || []);
            setPagination(prev => ({
                ...prev,
                current_page: result?.data?.pagination?.current_page || prev.current_page,
                per_page: result?.data?.pagination?.per_page || prev.per_page,
                total_pages: result?.data?.pagination?.total_pages || prev.total_pages,
                total: result?.data?.pagination?.total_resumes || prev.total,
            }));
            setLoadData(false);
        };

        if (isDataReady) {
            fetchCandidates();
        }
    }, [pagination.current_page, isDataReady]);



    const parsedSkills = data?.skills ? JSON.parse(data.skills) : [];
    const locationTag = data?.location;
    let parsedExperience = [];

    try {
        if (typeof data?.experience === "string") {
            const parsed = JSON.parse(data.experience);
            parsedExperience = Array.isArray(parsed) ? parsed : [parsed];
        } else if (Array.isArray(data?.experience)) {
            parsedExperience = data.experience;
        } else if (data?.experience) {
            parsedExperience = [data.experience];
        }
    } catch (e) {
        parsedExperience = [data.experience];
    }






    const handlePageChange = (newPage) => {
        if (!loadData && newPage !== pagination.current_page) {
            setPagination((prev) => ({
                ...prev,
                current_page: newPage,
            }));
        }
    };

    const handleRowClick = async (id, experience, location, designation) => {
        const minimalData = {
            id: id,
            jobId: data.jobId,
            jobTitle: data.jobTitle,
            location: location,
            experience: experience,
            designation: designation,
            type: data.type
            //highlightskill: selectedFilters.skills,
            //highlightCompany: selectedFilters.company_name,
            //highlightIndustry: selectedFilters.industry_name,
            //highlightLocation:selectedFilters.location

        };
        const payload = {
            resume_id: id
        }
        const ressult = await dispatch(viewResume(token, payload))
        if (ressult?.status === 200 || ressult?.status === 201) {
            const encodedData = btoa(encodeURIComponent(JSON.stringify(minimalData)));
            const detailsURL = `/dashboard/row-details?data=${encodedData}`;
            await dispatch(getUserDetails(token))
            window.open(detailsURL, '_blank');

        }
        else {
            await dispatch(getUserDetails(token))

        }
    }

    return (
        <>
            <CreditContent />
            {loading && <Loader />}
            <div className='resume-header'>
                <div className='tag'>
                    <div className="selected-filters">
                        {/* Skills */}
                        {parsedSkills.map((skill, index) => (
                            <div key={`skill-${index}`} className="filter-tab">
                                {skill}  </div>
                        ))}

                        {/* Industries */}
                        {locationTag && (
                            <div className="filter-tab">
                                {locationTag} </div>
                        )}

                        {parsedExperience && (
                            <div className="filter-tab">
                                {parsedExperience.length && parsedExperience.join(", ") + " Yrs"} </div>
                        )}
                    </div>
                </div>

            </div>
            <div className="resume">
                <div className="resume-container">

                    <div className="resume-title">
                        <div className='resume-count'>
                            {pagination.total} {data.type === "Passive" ? "Passive Candidates" : "Applicants"}: {data.jobTitle}

                        </div>
                        {result?.length > 0 &&
                            <CustomPagination
                                totalPages={pagination.total_pages}
                                currentPage={pagination.current_page}
                                onPageChange={handlePageChange}
                                isLoading={loadData} />}
                    </div>
                    <div class="list-container">
                        {loadData ? (
                            <div className="skeleton-container fade-in">
                                {Array.from({ length: 3 }).map((_, index) => (
                                    <SkeletonLoader key={index} />
                                ))}
                            </div>
                        ) : result && result.length > 0 ?
                            (result.map((resumedata, index) => {
                                return (
                                    <div class="list-items">
                                        <Card>
                                            <Card.Body class="card-left">

                                                <Card.Title>
                                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                        <div className='hover-title-card'
                                                            onClick={() => handleRowClick(resumedata.id, resumedata?.candidate_experience, resumedata?.location, resumedata?.designation)}>
                                                            {resumedata.candidate_name}<span style={{ marginLeft: "15px", position: "relative", top: "3px" }}>{resumedata?.is_view === true && (
                                                                <>
                                                                    <img
                                                                        src={""}
                                                                        alt='viewed'
                                                                        id={`view-tooltip-${resumedata.id}`}
                                                                        height={20}
                                                                        width={20}
                                                                    />
                                                                    <Tooltip
                                                                        anchorId={`view-tooltip-${resumedata.id}`}
                                                                        content="Viewed"
                                                                        place="top"
                                                                        className="custom-tooltip"
                                                                    />
                                                                </>
                                                            )}
                                                                {resumedata?.is_owner === true && (
                                                                    <>
                                                                        <img
                                                                            src={eyeIcon}
                                                                            alt='owner'
                                                                            id={`owner-tooltip-${resumedata.id}`}
                                                                            height={20}
                                                                            width={20}
                                                                        />
                                                                        <Tooltip
                                                                            anchorId={`owner-tooltip-${resumedata.id}`}
                                                                            content="Resume uploaded by me"
                                                                            place="top"
                                                                            className="custom-tooltip"
                                                                        />
                                                                    </>
                                                                )}
                                                                {resumedata?.is_owner === true && (
                                                                    <>
                                                                        <img
                                                                            src={""}
                                                                            alt='owner'
                                                                            id={`owner-tooltip-${resumedata.id}`}
                                                                            height={20}
                                                                            width={20}
                                                                        />
                                                                        <Tooltip
                                                                            anchorId={`owner-tooltip-${resumedata.id}`}
                                                                            content="Resume uploaded by me"
                                                                            place="top"
                                                                            className="custom-tooltip"
                                                                        />
                                                                    </>
                                                                )}</span>
                                                        </div>
                                                        {
                                                            resumedata?.current_status && (
                                                                <div className='resume-status-screening-container' style={{ flexDirection: "row", minWidth: "410px", gap: "5px" }}>
                                                                    <div className="status-progress-bar">
                                                                        <div className="status-progress-fill"
                                                                            style={{ width: `${resumedata.progress_percent}%` }}></div>
                                                                    </div>
                                                                    <p className="status-progress-percentage">{resumedata.progress_percent}%</p>
                                                                    <p className="screening-applied-button"><img src={touchIcon} />{resumedata.current_status} for <span style={{ color: "#002DCC", fontWeight: "700" }}>{data.jobTitle}</span></p>
                                                                </div>
                                                            )}
                                                    </div>
                                                </Card.Title>
                                                <Card.Subtitle className="designation">
                                                    {
                                                        (() => {
                                                            // const isLocationHighlighted = selectedFilters?.location?.some(filter => resumedata.location?.toLowerCase().includes(filter.toLowerCase()));
                                                            return (
                                                                <span className="designation-container">
                                                                    {resumedata.designation}
                                                                    <FaLocationDot />
                                                                    <span className="location">
                                                                        {resumedata.location}
                                                                    </span>
                                                                </span>
                                                            );
                                                        })()
                                                    }
                                                </Card.Subtitle>
                                                <Card.Text class="experience"> Experience: {resumedata.candidate_experience} Year(s)</Card.Text>
                                                <Card.Text className="skills">
                                                    Skills:
                                                    <>
                                                        {
                                                            (() => {
                                                                const allSkills = resumedata?.skills || [];
                                                                const visibleSkills = allSkills.slice(0, 15);
                                                                const remainingSkillsCount = allSkills.length - visibleSkills.length;

                                                                return (
                                                                    <>
                                                                        {visibleSkills.map((skill, index) => (
                                                                            <span key={index} className="skill-badge">
                                                                                {skill}
                                                                            </span>
                                                                        ))}
                                                                        {remainingSkillsCount > 0 && (
                                                                            <span className="skill-badge">+{remainingSkillsCount}</span>
                                                                        )}
                                                                    </>
                                                                );
                                                            })()
                                                        }
                                                    </>
                                                </Card.Text>

                                            </Card.Body>
                                            <Card.Body class="card-right">
                                                <Card.Subtitle className="work-history-heading"><div class="work-icon"><MdWork /></div>
                                                    <div class="work-history-card">Work History</div></Card.Subtitle>
                                                <Card.Text class='work-history'>
                                                    {
                                                        resumedata.work_experience.map((work) => {

                                                            return (
                                                                <div key={index} className="work-item">
                                                                    <span className="work-badge"><b className="company"><RiArrowDropRightFill />
                                                                        {work.company}</b> - {work.designation} - From {work.duration} </span>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                )
                            }))
                            : (
                                <div className="no-list-items">
                                    There is no data to display
                                </div>
                            )
                        }
                        {result?.length > 0 &&
                            <CustomPagination
                                totalPages={pagination.total_pages}
                                currentPage={pagination.current_page}
                                onPageChange={handlePageChange}
                                isLoading={loadData}
                            />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default RelevantCandidate